import { useState, useEffect } from 'react';

const useIpAndCountry = () => {
    const [ipAddress, setIpAddress] = useState('');
    const [countryCode, setCountryCode] = useState('');

    useEffect(() => {
        const fetchIpAndCountry = async () => {
            try {
                // Primary service - ipapi.co (higher rate limits)
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();

                if (data.ip && data.country) {
                    setIpAddress(data.ip);
                    setCountryCode(data.country_code);
                    return;
                }
                
                // Fallback 1 - cloudflare
                const cfResponse = await fetch('https://cloudflare.com/cdn-cgi/trace');
                const cfText = await cfResponse.text();
                
                if (cfText) {
                    // Parse the response
                    const dataObj = cfText.trim().split('\n').reduce((obj, pair) => {
                        const parts = pair.split('=');
                        if (parts.length === 2) {
                            const [key, value] = parts;
                            return { ...obj, [key]: value };
                        }
                        return obj;
                    }, {});
                    
                    if (dataObj.ip) {
                        setIpAddress(dataObj.ip);
                        setCountryCode(dataObj.loc || '');
                        return;
                    }
                }

                // Fallback 2 - geolocation-db.com
                const geoResponse = await fetch('https://geolocation-db.com/json/');
                const geoData = await geoResponse.json();
                
                if (geoData.IPv4) {
                    setIpAddress(geoData.IPv4);
                    setCountryCode(geoData.country_code);
                }
            } catch (error) {
                console.error('Error fetching IP and Country Code:', error);
                // Last resort - use client-side detection if available
                try {
                    const rtcPeerConnection = new RTCPeerConnection({iceServers: []});
                    rtcPeerConnection.createDataChannel('');
                    rtcPeerConnection.createOffer().then(offer => rtcPeerConnection.setLocalDescription(offer));
                    rtcPeerConnection.onicecandidate = (ice) => {
                        if (ice.candidate) {
                            const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
                            const match = ipRegex.exec(ice.candidate.candidate);
                            if (match) {
                                setIpAddress(match[1]);
                                rtcPeerConnection.close();
                            }
                        }
                    };
                } catch (e) {
                    console.error('Failed to get IP via WebRTC:', e);
                }
            }
        };

        fetchIpAndCountry();
    }, []);

    return { ipAddress, countryCode };
};

export default useIpAndCountry;